<template>
    <div class="row">
            <div class="col-md-12">
                <div class="panel panel-default">
                    <div class="panel-body">
                        <table class="table b-table table-sm" id="tabela">
                            <tbody>
                                <template v-for="iterator of report">
                                    <tr :key="iterator.id" >
                                        <td class="headerLine text-right"> <b>Loja:</b> </td>
                                        <td colspan="6">{{ iterator.name }}</td>
                                    </tr>

                                    <template v-for="team of iterator.teams">
                                        <tr :key="team.id">
                                            <td class="headerLine text-right"> <b>Equipe:</b> </td>
                                            <td colspan="6">{{ team.name }}</td>
                                        </tr>

                                        <template v-for="goal of team.goals">
                                            <template v-if="goal.persons.length">
                                                <tr :key="goal.id">
                                                    <td class="headerLine text-right">Meta:</td>
                                                    <td>{{ goal.date_init | moment('DD/MM/YYYY') }} até {{ goal.date_end | moment('DD/MM/YYYY') }} - {{ goal.description }} ({{ goal.goal }})</td>
                                                </tr>
                                                <tr :key="goal.id+'_'">
                                                    <td class="headerLine text-center">Ranking</td>
                                                    <td class="headerLine text-left">Vendedor</td>
                                                    <td class="headerLine text-center">Meta</td>
                                                    <td class="headerLine text-center">Realizado</td>
                                                    <td class="headerLine text-center">Total de Vendas</td>
                                                    <td class="headerLine text-center">Tíket Médio</td>
                                                    <td class="headerLine text-center">Status Meta</td>
                                                </tr>

                                                
                                                <template v-for="(person, key) of goal.persons">
                                                    <tr :key="key">
                                                    <td class="text-center">{{key + 1}} º</td>
                                                    <td class="text-left">{{ person.user_name }}</td>
                                                    <td class="text-center">{{ goal.goal }}</td>
                                                    <td class="text-center">{{ person.qtd_vendas }}</td>
                                                    <td class="text-right">{{ person.total_vendas | price}}</td>
                                                    <td class="text-right">{{ (person.total_vendas / person.qtd_vendas) | price}}</td>
                                                    <td class="text-center">{{ (person.qtd_vendas - goal.goal) }}</td>
                                                    </tr>
                                                </template>
                                            </template>
                                        
                                        </template>

                                    </template>


                                </template>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
</template>

<script>
export default {
    props : {
        report : {
            type : Array,
            default : []
        }
    }
}
</script>